import styled from 'styled-components';

import { spacing, colors } from '../../../../../styles/theme';

export const List = styled.ul`
  display: flex;
  margin-top: ${spacing('6')};
  flex-direction: column;
`;

export const ListItem = styled.li`
  display: flex;
  margin: ${spacing('2')} 0;
`;

export const ListItemIcon = styled.img`
  display: block;
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: ${spacing('3')};
`;

export const TextHighLight = styled.strong`
  font-weight: 700;
  color: ${colors('white.base')};
`;
